// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"787":"f9bc3b73","897":"09eff5aa"}[chunkId] + ".chunk.js";
};